export default `
<div class="am-wrapper">
  <uib-alert class="message" ng-repeat="alert in $ctrl.alertMessages" type="{{alert.alert_type}}" close="$ctrl.closeAlert($index, alert.id)" ng-if="$ctrl.currentUser">
    <span ng-bind-html="alert.content"></span>
  </uib-alert>
</div>
`;
